import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  return <section aria-label="Llamada final a la acción" className="bg-brand-dark text-white py-24 px-4 relative border-t border-brand-border" data-id="element-86">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-87">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-6" data-id="element-88">
          <span className="text-xl" aria-hidden="true" data-id="element-89">
            🌍
          </span>{' '}
          PROFEPACK
        </div>
        <p className="text-xl md:text-2xl text-white/80 mb-4 italic" data-id="element-90">
          El próximo domingo podés seguir buscando actividades en Google.
        </p>
        <p className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-16" data-id="element-91">
          O podés tener todo resuelto desde hoy.
        </p>
        <div className="mb-12" data-id="element-92">
          <CountdownTimer data-id="element-93" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 max-w-2xl mx-auto" data-id="element-94">
          <div className="bg-brand-card p-6 rounded-2xl border-2 border-brand-accent flex flex-col items-center justify-between transform md:scale-105 z-10" data-id="element-95">
            <div className="font-bold text-brand-accent mb-3 text-sm" data-id="element-96">
              🏆 PACK COMPLETO ⭐
            </div>
            <div className="text-4xl font-heading font-bold text-brand-accent mb-6" data-id="element-97">
              $27.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48113651515648:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark py-4 rounded-2xl text-sm font-black transition-colors" data-id="element-98">
              → QUIERO MI MEGAPACK COMPLETO
            </button>
          </div>
          <div className="bg-brand-card p-6 rounded-2xl border border-brand-border flex flex-col items-center justify-between" data-id="element-99">
            <div className="font-bold text-white/60 mb-3 text-sm" data-id="element-100">
              🌍 SOCIALES PRIMARIA LISTA
            </div>
            <div className="text-3xl font-heading font-bold text-white mb-6" data-id="element-101">
              $19.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48097217970432:1', '_blank')} className="w-full bg-brand-accent/10 border border-brand-accent/30 hover:bg-brand-accent/20 text-brand-accent py-4 rounded-2xl text-sm font-black transition-colors" data-id="element-102">
              → QUIERO MIS 6 TOMOS
            </button>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/80 font-medium mb-16 text-sm" data-id="element-103">
          <span data-id="element-104">🔒 Pago 100% seguro</span>
          <span data-id="element-105">⚡ Acceso en 5 minutos</span>
          <span data-id="element-106">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-107">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
        <div className="border-t border-brand-border pt-12 max-w-2xl mx-auto" data-id="element-108">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-xs uppercase mb-4" data-id="element-109">
            <span aria-hidden="true" data-id="element-110">🌍</span> PROFEPACK
          </div>
          <p className="text-white/70 italic mb-2 text-sm" data-id="element-111">
            El sistema de planificación N°1 para docentes de Ciencias Sociales
            de primaria en Argentina.
          </p>
          <p className="text-white/70 italic text-sm" data-id="element-112">
            Porque enseñar ciencias sociales no debería costarte todos los
            domingos del año.
          </p>
        </div>
      </div>
    </section>;
}